// extracted by mini-css-extract-plugin
module.exports = {"bold":"RiskManagement_bold_1SKCa"};